// extracted by mini-css-extract-plugin
export default {"container":"CorrespondenceHistory_container__2PhMu","content":"CorrespondenceHistory_content__6NWcU","divider":"CorrespondenceHistory_divider__J8fCG"};